import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { extendedRequest } from '../../services';

export interface UploadAttachmentArgs {
  file?: File;
  files?: File[];
  endpoint: string;
  notify?: ({ progress }: { progress: number }) => void;
}

async function uploadAttachmentWithProgress({
  file,
  files,
  endpoint,
  notify,
}: UploadAttachmentArgs): Promise<BaseBackResponse | BackResponseFailure> {
  const body = new FormData();

  if (file) {
    body.append('fileBinary', file);
  }

  if (files) {
    files.forEach((fileItem) => {
      body.append('fileBinary', fileItem);
    });
  }

  try {
    const response = await extendedRequest<BaseBackResponse>(endpoint, {
      method: SUPPORTED_METHODS.POST,
      body,
      notify,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default uploadAttachmentWithProgress;
